import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "countdown", "timerDisplay"]
  static values = {
    restTime: Number,
    showCountdown: { type: Boolean, default: false }
  }

  connect() {
    console.log('workout-countdown controller connected' + this.showCountdownValue)
    this.updateDisplay()
    if (this.showCountdownValue && this.hasRestTimeValue) {
      this.startCountdown()
    }
  }

  showCountdownValueChanged() {
    this.updateDisplay()
  }

  updateDisplay() {
    if (this.showCountdownValue) {
      this.formTarget.classList.add('hidden')
      this.countdownTarget.classList.remove('hidden')
    } else {
      this.formTarget.classList.remove('hidden')
      this.countdownTarget.classList.add('hidden')
    }
  }

  toggleCountdown() {
    this.showCountdownValue = !this.showCountdownValue
  }

  hideCountdown() {
    this.showCountdownValue = false
  }

  showCountdown() {
    this.showCountdownValue = true
    if (this.hasRestTimeValue) {
      this.startCountdown()
    }
  }

  startCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
    
    let remainingTime = this.restTimeValue
    this.updateTimerDisplay(remainingTime)
    
    this.countdownInterval = setInterval(() => {
      remainingTime -= 1
      
      if (remainingTime <= 0) {
        clearInterval(this.countdownInterval)
        this.hideCountdown()
      } else {
        this.updateTimerDisplay(remainingTime)
      }
    }, 1000)
  }

  updateTimerDisplay(seconds) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    this.timerDisplayTarget.textContent = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  disconnect() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }
}
